<template>
  <div class="topnav-div fixed-top banCopy">
    <div class="top row d-flex">
      <div class="logo-div col-md-5 col-sm-12">
        <div
          class="d-block d-lg-none navbar-toggler tran-icon-button"
          id="tran-but"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1.5rem"
            height="1.5rem"
            fill="currentColor"
            class="bi bi-grid-fill"
            viewBox="0 0 16 16"
          >
            <path
              d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"
            />
          </svg>
          <span class="tran-span">菜单</span>
        </div>

        <img
          src="../image/Logo.png"
          class="logo mouseLink"
          @click="backHome()"
        />
      </div>
      <div class="search-div col-md-5 d-none d-lg-block">
        <div class="search-box">
          <div class="icon-div">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-search"
              viewBox="0 0 16 16"
            >
              <path
                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
              />
            </svg>
          </div>

          <input
            type="text"
            placeholder="请输入新闻的关键词"
            class="search-input"
            @keyup.enter="serch()"
          />

          <button class="submit" @click="serch()">搜索</button>
        </div>
      </div>
    </div>

    <div
      class="navbar-div collapse navbar-collapse d-lg-block"
      id="collapsibleNavbar"
    >
      <nav class="navbar navbar-expand-sm" id="navbar">
        <ul class="navbar-nav transition" id="navbar-ul">
          <li class="nav-item transition">
            <div
              class="d-block d-lg-none navbar-toggler tran-icon-button"
              id="nav-but"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1.5rem"
                height="1.5rem"
                fill="currentColor"
                class="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </div>
          </li>
          <li class="nav-item transition">
            <span
              class="list-nav-link mouseLink"
              id="aaa"
              @click="gotoPages($event)"
              >首页</span
            >
          </li>
          <li class="nav-item transition">
            <span class="list-nav-link mouseLink" @click="gotoPages($event)"
              >集团概况</span
            >
          </li>
          <li class="nav-item transition">
            <span
              class="list-nav-link mouseLink"
              id="aaa"
              @click="gotoPages($event)"
              >集团新闻</span
            >
          </li>
          <li
            class="drop-downMenu-dispaly drop-downMenu-link nav-item transition"
          >
            <span
              class="list-nav-link drop-downMenu mouseLink"
              @click="gotoPages($event)"
              >业务领域</span
            >
            <div
              class="p-3 mb-5 bg-body rounded drop-downMenu-div"
              id="drop-downMenu-div1"
            >
              <span
                class="drop-downMenu-item mouseLink"
                v-for="item in areasArr"
                :key="item"
                @click="gotoBusinessDetails(item.title, item.company_id)"
                >{{ item.title }}</span
              >
            </div>
          </li>
          <li
            class="nav-item transition drop-downMenu-dispaly drop-downMenu-link"
            id="drop-downMenu-dispaly2"
          >
            <span
              class="list-nav-link drop-downMenu mouseLink corporateCulture"
              @click="gotoPages($event)"
              >企业文化</span
            >
            <div
              class="drop-downMenu-div p-3 mb-5 bg-body rounded transition"
              id="drop-downMenu-div2"
            >
              <span
                class="drop-downMenu-item mouseLink"
                @click="gotoPages($event)"
                >党群建设</span
              >
              <span
                class="drop-downMenu-item mouseLink"
                @click="gotoPages($event)"
                >杭开文化</span
              >
            </div>
          </li>
          <li class="nav-item transition">
            <span class="list-nav-link mouseLink" @click="gotoPages($event)"
              >联系我们</span
            >
          </li>
          <li class="nav-item transition">
            <span class="list-nav-link mouseLink" @click="gotoPages($event)"
              >人员招聘</span
            >
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
  
<script scoped>
export default {
  name: "navbar",
  data() {
    return {
      areasArr: [],
      aaa: false,
    };
  },
  methods: {
    gotoPages: function (e) {
      var string = e.currentTarget.innerHTML;
      switch (string) {
        case "首页":
          this.$router.push({ name: "home" });
          this.showBox();
          break;
        case "集团概况":
          this.$router.push({ name: "overview" });
          this.showBox();
          break;
        case "集团新闻":
          this.$router.push({ name: "newsList" });
          this.showBox();
          break;
        case "业务领域":
          this.$router.push({ name: "areas" });
          this.showBox();
          break;
        case "企业文化":
          if (document.documentElement.clientWidth > 991) {
            this.$router.push("/corporateCulture/construction");
          } else {
            if (this.aaa == false) {
              $("#drop-downMenu-div2").css("display", "block");
              this.aaa = true;
            } else {
              $("#drop-downMenu-div2").css("display", "none");
              this.aaa = false;
            }
          }
          break;
        case "党群建设":
          this.$router.push("/corporateCulture/construction");
          this.showBox();
          break;
        case "杭开文化":
          this.$router.push("/corporateCulture/culture");
          this.showBox();
          break;
        case "联系我们":
          this.$router.push({ name: "contactUs" });
          this.showBox();
          break;
        case "人员招聘":
          this.$router.push({ name: "recruit" });
          this.showBox();
          break;
      }
    },
    showBox() {
      if (window.innerWidth <= 991) {
        $("#collapsibleNavbar").css("animation", "navbar-show 0.5s");
        $("#collapsibleNavbar").css("-webkit-animation", "navbar-show 0.5s");
        setTimeout(function () {
          $("#collapsibleNavbar").css("display", "none");
        }, 450);
      }
    },
    backHome() {
      this.$router.push({
        name: "home",
      });
    },
    gotoBusinessDetails(title, id) {
      this.$router.push({
        name: "businessDetails",
        query: {
          title: title,
          companyid: id,
        },
      });
    },
    serch() {
      var inputSrting = $(".search-input").val();
      if (inputSrting == "") {
        this.$router.push({ name: "newsList" });
      } else {
        this.$router.push({
          name: "newsList",
          query: {
            serchString: inputSrting,
          },
        });
      }
    },
    async Post() {
      var url = "http://demoapi.hkjt.cn/pages/business.php";

      await this.axios
        .get(url)
        .then((res) => {
          this.areasArr = res.data;
        })
        .catch((e) => {
          if (e.response) {
            //请求已发出，服务器返回状态码不是2xx。
            console.info(e.response.data);
            console.info(e.response.status);
            console.info(e.response.headers);
          } else if (e.request) {
            // 请求已发出，但没有收到响应
            // e.request 在浏览器里是一个XMLHttpRequest实例，
            // 在node中是一个http.ClientRequest实例
            console.info(e.request);
          } else {
            //发送请求时异常，捕捉到错误
            console.info("error", e.message);
          }
          console.info(e.config);
        });
    },
  },
  mounted() {
    this.Post();
    $(window).resize(function () {
      //console.log($(window).width())
      if ($(window).width() < 991) {
        $("#drop-downMenu-div2").css("display", "none");
        this.aaa = false;
      } else {
        $("#drop-downMenu-div2").css("display", "none");
        this.aaa = false;
      }
    });
  },
};

$(function () {
  $("#tran-but").on("click", function () {
    //显示
    $("#collapsibleNavbar").css("display", "block");
    $("#collapsibleNavbar").css("animation", "navbar-dispaly 0.5s");
    $("#collapsibleNavbar").css("-webkit-animation", "navbar-dispaly 0.5s");
  });

  $("#nav-but").on("click", function () {
    //隐藏
    $("#collapsibleNavbar").css("animation", "navbar-show 0.5s");
    $("#collapsibleNavbar").css("-webkit-animation", "navbar-show 0.5s");
    setTimeout(function () {
      $("#collapsibleNavbar").css("display", "none");
    }, 450);
  });
});
</script>
  
<style>
@media screen and (min-width: 991px) {
  #drop-downMenu-div2 {
    display: none;
  }

  .topnav-div {
    background-color: white;
  }

  .navbar-div {
    position: absolute;
  }

  .navbar-expand-sm {
    position: relative;
    left: 15%;
  }

  .nav-item {
    padding-right: 2rem;
    display: flex;
    min-height: 4rem;
    align-items: center;
    transition-duration: 0.4s;
    overflow: hidden;
  }

  .navbar-nav {
    display: flex;
  }

  #collapsibleNavbar {
    display: block;
  }

  .drop-downMenu-dispaly:hover .drop-downMenu-div {
    display: block;
    animation: drop-downMenu-dispaly 0.5s;
  }

  #drop-downMenu-dispaly2:hover #drop-downMenu-div2 {
    display: block;
    animation: drop-downMenu-dispaly 0.5s;
  }

  .drop-downMenu-div {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
}

@keyframes drop-downMenu-dispaly {
  0% {
    transform-origin: top;
    transform: scale(1, 0);
  }

  100% {
    transform-origin: top;
    transform: scale(1, 1);
  }
}

@keyframes navbar-dispaly {
  0% {
    left: -50%;
  }

  100% {
    left: 0;
  }
}

@keyframes navbar-show {
  0% {
    left: 0;
  }

  100% {
    left: -55%;
  }
}

.topnav-div {
  background-color: #fff;
}

.tran-icon-button {
  display: flex;
  flex-direction: column;
  width: fit-content;
  border: 0;
  background: #fff;
  position: absolute;
  top: 1.5rem;
  left: 0.7rem;
}

.drop-downMenu-div {
  position: absolute;
  display: none;
  top: 3.5rem;
  background-color: rgb(255, 255, 255);
  line-height: 2.3rem;
  color: #909399;
}

.drop-downMenu-item {
  display: block;
  padding-top: 0.5rem;
  padding: 0 0.8rem 0.1rem 0;
  color: rgb(144, 147, 153);
  font-size: 0.875rem;
}

.drop-downMenu-item:hover {
  color: #237fef;
}

.tran-span {
  display: block;
  font-size: 0.7rem;
  padding-top: 0.4rem;
}

.top {
  display: flex;
  justify-items: center;
  padding-top: 1.5rem;
  margin-bottom: 2rem;
}

.top > div {
  display: flex;
  justify-content: center;
  margin: 0 auto;
}

.logo {
  height: 3rem;
}

.search-div {
  display: flex;
  justify-items: center;
}

.search-box {
  border: 1px solid #b4bccca1;
  width: 25rem;
  height: 2.5rem;
  border-radius: 30rem;
  display: flex;
  align-items: center;
  margin: 0 auto;
}

.search-box:focus-within {
  border: 1px solid #409eff;
}

.icon-div {
  color: #b4bccc;
  text-align: right;
  padding-left: 2rem;
}

/* Safari，Chrome WebKit browsers */
input::-webkit-input-placeholder {
  color: #b4bccc;
}

/* 火狐 Mozilla Firefox 4 to 18 */
input:-moz-placeholder {
  color: #b4bccc;
}

/* 火狐 Mozilla Firefox 19+ */
input::-moz-placeholder {
  color: #b4bccc;
}

/* Internet Explorer 10+ */
input:-ms-input-placeholder {
  color: #b4bccc;
}

.search-input {
  height: 100%;
  border: 0px;
  padding-left: 1rem;
  color: #606266;
  font-size: 0.875rem;
  width: 65%;
  outline: none;
}

.search-input:focus {
  border: 0;
}

.submit {
  background-color: #409eff;
  color: #fff;
  border: 0;
  box-shadow: 0;
  height: 90%;
  width: 5.5rem;
  border-radius: 30rem;
  font-size: 0.875rem;
  line-height: 100%;
  font-family: Arial;
}

.submit:hover {
  background-color: #40a0ffc2;
}

.navbar-div {
  background-color: #237fef;
  width: 100%;
  color: #fff;
  moz-user-select: -moz-none;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: block;
}

#navbar {
  padding: 0;
}

.navbar-nav {
  height: 100%;
}

.list-nav-link {
  font-size: 1.125rem;
  transition-duration: 0.4s;
}

.dropdown:hover .dropdown-menu {
  display: block;
  margin-top: 17rem;
}

#nav-but {
  border: 0;
}

@media screen and (max-width: 991px) {
  .drop-downMenu-item{
    color: #2a2e2e;
  }

  .top {
    margin-bottom: 0;
  }

  .navbar-nav :nth-child(2) {
    margin-top: 1rem;
  }

  .navbar-expand-sm {
    margin-left: 2rem;
  }

  .nav-item {
    height: 3rem;
  }

  .drop-downMenu {
    min-height: 3rem;
  }

  #collapsibleNavbar {
    position: absolute;
    top: 0;
    background-color: white;
    display: none;
    color: #2a2e2e;
    box-shadow: 0.1rem 0.1rem 0.5rem #2a2e2e41;
    width: 50%;
    margin: 0;
    height: 100vh;
  }

  .navbar-nav {
    display: block;
    height: 100%;
  }

  #navbar-ul {
    display: block;
  }

  .tran-icon-button {
    border: 0;
    -moz-user-select: none;
    /* Firefox私有属性 */
    -webkit-user-select: none;
    /* WebKit内核私有属性 */
    -ms-user-select: none;
    /* IE私有属性(IE10及以后) */
    -khtml-user-select: none;
    /* KHTML内核私有属性 */
    -o-user-select: none;
    /* Opera私有属性 */
    user-select: none;
    /* CSS3属性 */
  }

  .list-nav-link:hover {
    color: #237fef;
  }

  .drop-downMenu {
    width: 100%;
  }

  .drop-downMenu-link {
    display: flex;
    flex-direction: column;
  }

  .drop-downMenu-div {
    margin-top: 0 !important;
    box-shadow: 0;
  }

  .drop-downMenu {
    margin: auto 0 auto 0;
  }

  #drop-downMenu-div2 {
    display: none;
    width: 100%;
    position: static;
    margin-bottom: 0 !important;
    font-size: 1.2rem;
    color: #2a2e2e;
    padding-top: 0 !important;
    animation: drop-downMenu-dispaly 0.5s;
    min-height: 0;
    max-height: 999rem;
  }

  .logo-div {
    padding-bottom: 1rem;
    transition-duration: 0.8s;
  }

  .navbar-div {
    display: none;
  }

  .drop-downMenu-dispaly {
    height: auto;
  }
}

@media screen and (max-width: 576px) {
  .list-nav-link {
    font-size: 1rem;
    transition-duration: 0.4s;
  }

  .nav-item {
    transition-duration: 0.4s;
  }

  .drop-downMenu-link {
    /* height: auto; */
  }

  #drop-downMenu-div2 {
    font-size: 1rem;
  }
}
</style>
  